import React from 'react'

function AnnounceIcon() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M76.875 14.9809V5H78.125V75H76.875V65.0191L50.8523 60.1616V66.5C50.8523 69.6066 48.3339 72.125 45.2273 72.125H21.1364C18.0298 72.125 15.5114 69.6066 15.5114 66.5V53.5646L6.46783 51.8765C3.80528 51.3794 1.875 49.0555 1.875 46.347V33.653C1.875 30.9445 3.80528 28.6206 6.46783 28.1235L76.875 14.9809ZM76.875 16.2525L6.6972 29.3523C4.62633 29.7389 3.125 31.5464 3.125 33.653V46.347C3.125 48.4536 4.62633 50.2611 6.6972 50.6477L76.875 63.7475V16.2525ZM16.7614 53.7979V66.5C16.7614 68.9162 18.7201 70.875 21.1364 70.875H45.2273C47.6435 70.875 49.6023 68.9162 49.6023 66.5V59.9282L16.7614 53.7979Z" fill="#F4F4F4"/>
    </svg>
  )
}

export default AnnounceIcon
